module.exports = __webpack_public_path__ + "static/media/av5.2b210466.JPG";